import { networkService } from "services/networkService";
import {
  METHOD_VSP_360_VERSION_LIST,
  METHOD_VSP_360_VERSION_CREATE,
  METHOD_VSP_360_VERSION_UPDATE,
  METHOD_VSP_360_VERSION_DELETE,
  METHOD_VSP_360_VERSION_DETAIL,

  METHOD_VSP_360_SERVICES_LIST,
  METHOD_VSP_360_SERVICES_CREATE,
  METHOD_VSP_360_SERVICES_UPDATE,
  METHOD_VSP_360_SERVICES_DELETE,
  METHOD_VSP_360_SERVICES_DETAIL,

} from "constants/admin/masters/vsp360";


class vsp360Service {

  //VSP 360 VERSION TYPE METHODS
  getAllVSP360Version = (data) => {
    return networkService
      .post(METHOD_VSP_360_VERSION_LIST, data)
      .then((response) => response.data);
  };
  getVSP360VersionDetail = (id) => {
    const updatedMethodName = METHOD_VSP_360_VERSION_DETAIL.replace("{ID}", id);
    return networkService
      .get(updatedMethodName)
      .then((response) => response.data);
  };
  createVSP360Version = (data) => {
    return networkService
      .post(METHOD_VSP_360_VERSION_CREATE, data)
      .then((response) => response.data);
  };
  updateVSP360Version = (data, id) => {
    const updatedMethodName = METHOD_VSP_360_VERSION_UPDATE.replace("{ID}", id);
    return networkService
      .post(updatedMethodName, data)
      .then((response) => response.data);
  };
  deleteVSP360Version = (id, is_delete = false) => {
    const updatedMethodName = METHOD_VSP_360_VERSION_DELETE.replace("{ID}", id);
    return networkService
      .delete(updatedMethodName, { data: { is_delete } })
      .then((response) => response.data);
  };

  //VSP 360 Services METHODS
  getAllVSP360Services = (data) => {
    return networkService
      .post(METHOD_VSP_360_SERVICES_LIST, data)
      .then((response) => response.data);
  };
  getVSP360ServicesDetail = (id) => {
    const updatedMethodName = METHOD_VSP_360_SERVICES_DETAIL.replace("{ID}", id);
    return networkService
      .get(updatedMethodName)
      .then((response) => response.data);
  };
  createVSP360Services = (data) => {
    return networkService
      .post(METHOD_VSP_360_SERVICES_CREATE, data)
      .then((response) => response.data);
  };
  updateVSP360Services = (data, id) => {
    const updatedMethodName = METHOD_VSP_360_SERVICES_UPDATE.replace("{ID}", id);
    return networkService
      .post(updatedMethodName, data)
      .then((response) => response.data);
  };
  deleteVSP360Services = (id, is_delete = false) => {
    const updatedMethodName = METHOD_VSP_360_SERVICES_DELETE.replace("{ID}", id);
    return networkService
      .delete(updatedMethodName, { data: { is_delete } })
      .then((response) => response.data);
  };

}
export default vsp360Service;